export enum ETenantSettingActionType {
  UpdateTenantSettings,
  UpdateMetadata,
  DeleteTag,
  InsertTag,
  UpdateTag,
  DeleteQCWorkflowObjective,
  InsertQCWorkflowObjective,
  UpdateQCWorkflowObjective,
}
export class ChangeToApprove {
  public get id() {
    return this.sourceId;
  }
  constructor(
    public sourceId: number,
    public actionType: ETenantSettingActionType,
    public message: string,
  ) {}
}
